// extracted by mini-css-extract-plugin
export var categories = "Categories-module--categories--f3389";
export var categories__header = "Categories-module--categories__header--666ad";
export var categories__list = "Categories-module--categories__list--e5425";
export var categories__list_item = "Categories-module--categories__list_item--1816f";